import React, { useMemo } from 'react';
import { get } from 'lodash';
import useGetSavedDashboard from '@components/saving/useGetSavedDashboard';
import Retry from '../Retry';
import { createStore } from 'jotai';
import { savedDashboardCreatorIdAtom } from '@src/components/saving/atoms';
import { isSavedDashboardAtom, isPublicSavedDashboardAtom } from '@src/atoms/pageMeta';
import { useParams } from 'react-router-dom';

function SavedDashboardHOC({ children, applySavedData, initStore = createStore, ...props }) {
  const { id } = useParams();

  const { ready, isError, refetch, savedData = {} } = useGetSavedDashboard(id, applySavedData);

  // intialize jotai store with default state
  // reusing share init as parameters for save/share are same
  const store = useMemo(() => {
    if (ready) {
      const state = get(savedData, ['config', 'state'], {});

      // workaround for usecaseKey as it's location
      // is different between save and share config
      const usecaseKey = get(savedData, ['config', 'usecaseKey'], null);

      const store = usecaseKey ? initStore({ ...state, usecaseKey }) : initStore(state);
      store.set(savedDashboardCreatorIdAtom, savedData.creatorId);
      store.set(isSavedDashboardAtom, true);
      store.set(isPublicSavedDashboardAtom, Boolean(savedData.isPublic));
      return store;
    }
    return null;
  }, [savedData, ready, initStore]);

  const childrenProps = {
    ...props,
    id,
    isSavedDashboard: true,
    savedDashboardCreatorId: savedData.creatorId,
    store,
  };

  return (
    <Retry
      fetchData={refetch}
      // wait for apply to happen before rendering
      isLoading={!ready}
      showError={isError}
      progress={true}
      mountChildAlways={false}
    >
      <>{ready ? children(childrenProps) : 'Loading...'}</>
    </Retry>
  );
}

export default SavedDashboardHOC;
